import React from "react";
import { Loader2, Save } from "lucide-react";

export const L = ({ label, children, hint }) => (
  <div>
    <label className="font-mono text-[10px] uppercase tracking-widest text-ink-muted block mb-1">{label}</label>
    {children}
    {hint && <p className="text-[11px] text-ink-muted mt-1">{hint}</p>}
  </div>
);

export const SaveBtn = ({ onClick, saving, label = "Salvează", testid = "cc-save" }) => (
  <button onClick={onClick} disabled={saving} data-testid={testid}
    className="inline-flex items-center gap-2 px-5 py-2.5 bg-ink text-white text-sm rounded-lg hover:bg-brand transition-colors disabled:opacity-60">
    {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} {label}
  </button>
);

export const Toggle = ({ checked, onChange, label, testid }) => (
  <label className="flex items-center gap-2 text-[13px] text-ink cursor-pointer select-none">
    <input type="checkbox" checked={!!checked} onChange={e => onChange(e.target.checked)} data-testid={testid}
      className="h-4 w-4 accent-[#111]" />
    {label}
  </label>
);

export const Card = ({ children, className = "", ...rest }) => (
  <div className={`bg-white border border-neutral-200 rounded-xl p-6 ${className}`} {...rest}>{children}</div>
);

export const SectionTitle = ({ children, sub }) => (
  <div className="mb-3">
    <div className="font-display font-semibold text-ink">{children}</div>
    {sub && <p className="text-[12px] text-ink-muted">{sub}</p>}
  </div>
);

export function genPassword() {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789";
  let p = ""; for (let i = 0; i < 10; i++) p += chars[Math.floor(Math.random() * chars.length)];
  return p + "!";
}

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso); if (isNaN(d)) return String(iso).slice(0, 10);
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
};

export const INP_STYLE = `.inp{width:100%;border:1px solid #e5e5e5;border-radius:8px;padding:8px 10px;font-size:13px;outline:none;background:#fff}.inp:focus{border-color:#111}.inp:disabled{background:#f7f7f7;color:#999}`;

// ISO (YYYY-MM-DD) <-> afișare DD/MM/YYYY (input mascat ZZ/LL/AAAA)
const isoToDisplay = (iso) => { const m = String(iso || "").match(/^(\d{4})-(\d{2})-(\d{2})/); return m ? `${m[3]}/${m[2]}/${m[1]}` : ""; };
const displayToIso = (txt) => {
  const m = String(txt).match(/^(\d{2})\/(\d{2})\/(\d{4})$/); if (!m) return null;
  const [, dd, mm, yyyy] = m; const d = new Date(`${yyyy}-${mm}-${dd}T00:00:00`);
  return (isNaN(d) || d.getDate() !== +dd || d.getMonth() + 1 !== +mm) ? null : `${yyyy}-${mm}-${dd}`;
};
export function DateInput({ value, onChange, className = "inp", testid }) {
  const [text, setText] = React.useState(isoToDisplay(value));
  React.useEffect(() => { setText(isoToDisplay(value)); }, [value]);
  function handle(raw) {
    const digits = raw.replace(/\D/g, "").slice(0, 8);
    const out = digits.length > 4 ? `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}` : digits.length > 2 ? `${digits.slice(0, 2)}/${digits.slice(2)}` : digits;
    setText(out);
    if (out === "") onChange("");
    else { const iso = displayToIso(out); if (iso) onChange(iso); }
  }
  return <input value={text} onChange={e => handle(e.target.value)} placeholder="ZZ/LL/AAAA" inputMode="numeric" className={className} data-testid={testid} />;
}
